import { Injectable } from '@angular/core';
import { Observable, Subscriber } from 'rxjs';
import 'rxjs/add/operator/map';
import { HttpClientService } from '../http-client/http-client.service';
import { Service } from '../service';
import { PaymentConcept } from '../../models/payment-concept/payment-concept';

@Injectable()
export class PaymentConceptService extends Service {

    public paymentConcept: PaymentConcept[];
    public paymentConceptObject: any;

    constructor(
        private http: HttpClientService
    ) {
        super();
        this.paymentConcept = [];
        this.paymentConceptObject = {};
    }

    public getAll(): Observable<PaymentConcept[]> {
        if (!!this.paymentConcept && this.paymentConcept.length > 0) {
            return Observable.create((observer: Subscriber<PaymentConcept[]>) => {
                observer.next(this.paymentConcept);
                observer.complete();
            });
        }
        const url = 'paymentconcepts/all';
        return this.http.get(url).map(response => {
            const r = response.json();
            let filtered = [];
            if (r.ResultCode === 1) {
                filtered = r.Result.filter(e => e.Id !== 100);
                this.paymentConcept = filtered;
                this.paymentConceptObject = filtered.reduce((result, st) => {
                    result[String(st.Id)] = result[String(st.Id)] || {};
                    result[String(st.Id)] = st;
                    return result;
                }, {});
            } else {
                console.error('divisionsService > getAll > response', r);
            }
            return filtered;
        }).catch(this.handleError);
    }
}



// WEBPACK FOOTER //
// ./src/app/main/services/payment-concept/payment-concept.service.ts